import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { CohortModule } from '../cohort/cohort.module';
import { GenericTileModule } from '../generic-tile/generic-tile.module';
import { LiveClassCarouselBannersComponent } from '../live-class-carousel-banners/live-class-carousel-banners.component';
import { LiveClassPcPromoModalComponent } from '../live-class-pc-promo-modal/live-class-pc-promo-modal.component';
import { LiveClassRevampModule } from '../live-class-revamp/live-class-revamp.module';
import { LiveClassSharedModule } from '../live-class-shared/live-class-shared.module';
import { LiveClassUnavailableModule } from '../live-class-unavailable/live-class-unavailable.module';
import { MktBannerComponent } from '../mkt-banner/mkt-banner.component';
import { LiveClassSectionComponent } from './live-class-section.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CohortModule,
    GenericTileModule,
    LiveClassRevampModule,
    LiveClassSharedModule,
    LiveClassUnavailableModule,
  ],
  declarations: [
    LiveClassSectionComponent,
    LiveClassCarouselBannersComponent,
    LiveClassPcPromoModalComponent,
    MktBannerComponent,
  ],
  exports: [LiveClassSectionComponent, LiveClassUnavailableModule],
  entryComponents: [LiveClassPcPromoModalComponent],
})
export class LiveClassSectionModule {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/live-class-section.module.ts